import { Component, inject, input, type OnInit, signal } from "@angular/core";
import type { ChartConfiguration } from "chart.js";
import { BaseChartDirective } from "ng2-charts";

import { AdaaHelper } from "../../../../core/utils";
import { ChartsService, SystemLayoutService } from "../../../services";
import { DataProviderService } from "./_data-provider-service";

@Component({
  selector: "adaa-entity-overall-performance",
  imports: [BaseChartDirective],
  templateUrl: "./entity-overall-performance.html",
  styleUrl: "./entity-overall-performance.scss",
})
export class EntityOverallPerformanceComponent implements OnInit {
  private readonly _systemLayoutService = inject(SystemLayoutService);
  private readonly _dataProvider = inject(DataProviderService);
  private readonly _chartService = inject(ChartsService);

  entityId = input<number>();
  periodId = input<number>();
  aggregationType = input<number>();

  chartData = signal<ChartConfiguration<"line">["data"]>({
    labels: [],
    datasets: [],
  });
  chartOptions = signal<ChartConfiguration<"line">["options"] | undefined>(undefined);

  private readonly _untilDestroyed = AdaaHelper.untilDestroyed();

  public ngOnInit() {
    this._getData();

    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => this._getData(),
    });

    this._systemLayoutService.hasCycleChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => this._getData(),
    });
  }

  private _getData() {
    this._dataProvider.gatherData(this.aggregationType()!, this.entityId()!, this.periodId()!).subscribe({
      next: (data) => {
        this._chartService.initLineChartOptions({
          title: "",
          isRank: false,
        });

        this.chartOptions.update(() => ({
          ...this._chartService.lineChartOptions,
        }));

        this.chartData.update(() => data as ChartConfiguration<"line">["data"]);
      },
    });
  }
}
